import { render, staticRenderFns } from "./LogisticsChart.vue?vue&type=template&id=773404f0&scoped=true"
import script from "./LogisticsChart.vue?vue&type=script&lang=js"
export * from "./LogisticsChart.vue?vue&type=script&lang=js"
import style0 from "./LogisticsChart.vue?vue&type=style&index=0&id=773404f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773404f0",
  null
  
)

export default component.exports